
  <template>
    <v-card>
        <v-card-title>
            <v-row>
                <v-col cols="2">
                    <v-text-field
                        label="ИД пространства"
                        placeholder="ИД пространства"
                        v-model="filters.id"
                        outlined
                        dense
                        clearable
                    ></v-text-field>
                </v-col>
                <v-col cols="2">
                    <v-text-field
                        label="ИНН"
                        placeholder="ИНН"
                        v-model="filters.organizations.inn"
                        outlined
                        dense
                        clearable
                    ></v-text-field>
                </v-col>
                <v-col cols="2">
                    <v-text-field
                        label="Название организации"
                        placeholder="Название организации"
                        v-model="filters.organizations.full_name"
                        outlined
                        dense
                        clearable
                    ></v-text-field>
                </v-col>
                <v-col cols="2">
                    <v-text-field
                        label="email"
                        placeholder="email"
                        v-model="filters.users.email"
                        outlined
                        dense
                        clearable
                    ></v-text-field>
                </v-col>
                <v-col cols="2">
                    <v-btn color="success" @click="onSearch">Поиск</v-btn>
                </v-col>
            </v-row>
        </v-card-title>
        <v-data-table
            :loading="isFetching"
            :headers="headers"
            :items="workspaces"
            class="elevation-1"
            :items-per-page.sync="meta.per_page"
            hide-default-footer
        >
            <template v-slot:[`item.actions`]="{ item }">
                <v-btn color="warning" @click="onBtnCheckout(item.id)">Переключиться</v-btn>
            </template>
            <template v-slot:[`item.more`]="{ item }">
                <v-btn color="success" @click="onMoreWorkspace(item.id)">Подробнее</v-btn>
            </template>
            <template v-slot:[`item.info`]="{ item }">
                {{item.count_organizations}} / {{item.count_users}}
            </template>
        </v-data-table>
        <div class="text-center pt-2">
            <v-pagination
                @input="load"
                v-model="meta.current_page"
                :length="meta.last_page"
            ></v-pagination>
        </div>
        <v-row justify="center">
            <workspace-list-dialog v-if="dialog" :dialog.sync="dialog" :workspaceId="moreWorkspaceId"></workspace-list-dialog>
        </v-row>
    </v-card>
</template>

<script>
import * as api from '@/api/admin/workspaces';
import { mapActions} from 'vuex';
import WorkspaceListDialog from './WorkspaceListDialog.vue';
export default {
    name: 'WorkspaceList',
    components: {
        WorkspaceListDialog
    },
    data: () => ({
        isFetching: false,
        moreWorkspaceId: null,
        dialog: false,
        headers: [
          {
            text: 'actions',
            align: 'start',
            sortable: false,
            value: 'actions'
          },
          { text: 'id', value: 'id' },
          { text: 'name', value: 'name' },
          { text: 'Кол-во организаций/пользователей', value: 'info' },
          { text: 'more', value: 'more' },
        ],
        workspaces: [],
        meta: {},
        filters: {
            id: '',
            organizations: {
                inn: '',
                full_name: ''
            },
            users: {
                email: '',
            },
        },
    }),
    created () {
        this.load();
    },
    methods: {
        onSearch(){
            this.meta.current_page = 1;
            this.load();
        },
        onMoreWorkspace(id){
            this.moreWorkspaceId = id;
            this.dialog = true; 
        },
        onBtnCheckout(id){
            this.checkout(id);
        },
        async load(){
            this.isFetching = true;
            try{
                let response = await api.index({page: this.meta.current_page, per_page: this.meta.per_page}, this.activeFilters);
                this.setMeta({...response.data, data: null});
                this.setWorkspaces(response.data.data);
            }catch(e){
                this.SHOW_ERROR('Ошибка загрузки пространств');
                console.log(e);
            }finally{
                this.isFetching = false;
            }
        },
        async loadWorkspace(id){
            let response = await api.show(id);
            return response;
        },
        setWorkspaces(data){
            this.workspaces.splice(0, this.workspaces.length, ...data);
        },
        setMeta(data){
            this.meta = {...this.meta, ...data};
        },
        checkout(workspaceId){
            this.CHECKOUT_WORKSPACE_ADMIN(workspaceId);
            // this.SET_LOADING();
            // this.loadWorkspace(workspaceId).then((response) => {
            //     this.SET_WORK_SPACE(response.data.data);
            //     this.SHOW_SUCCESS('Пространство успешно установлено');
            // }).catch((err) => {
            //     this.SET_FETHCING();
            //     this.SHOW_ERROR('Ошибка переключения на пространство');
            //     console.log(err);
            // });
        },
        ...mapActions('workspace', ['SET_WORK_SPACE', 'SET_LOADING', 'SET_FETHCING', 'CHECKOUT_WORKSPACE_ADMIN']),
        ...mapActions('notifications', ['SHOW_SUCCESS', 'SHOW_ERROR']),
    },
    computed:{
        activeFilters: function () {
            let filters = {};
            if(this.filters.id !== ''){
                filters.id = this.filters.id;
            }
            // eslint-disable-next-line no-unused-vars
            const orgFiltered = Object.entries(this.filters.organizations).filter(([key, value]) => value != null && value !== '');
            if(orgFiltered.length > 0){
                filters.organizations = {};
                for (let item of orgFiltered) {
                    filters.organizations[item[0]] = item[1];
                }
            }
            // eslint-disable-next-line no-unused-vars
            const userFiltered = Object.entries(this.filters.users).filter(([key, value]) => value != null && value !== '');
            if(userFiltered.length > 0){
                 filters.users = {};
                for (let item of userFiltered) {
                    filters.users[item[0]] = item[1];
                }
            }
            return filters;
        }
    },
}
</script>